import { useEffect, useMemo, useState } from 'react';

/**
 * Track user geolocation once and provide an effective map center.
 * @param {[number, number]|null} center
 * @param {[number, number]} [fallbackCenter]
 * @returns {{ userPosition: [number, number]|null, hasGeolocated: boolean, effectiveCenter: [number, number], setUserPosition: Function, setHasGeolocated: Function }}
 */
export function useUserLocation(center, fallbackCenter = [34.0522, -118.2437]) {
	const [userPosition, setUserPosition] = useState(null);
	const [hasGeolocated, setHasGeolocated] = useState(false);

	useEffect(() => {
		if (hasGeolocated || center) return;
		if (!navigator?.geolocation) return;

		navigator.geolocation.getCurrentPosition(
			(position) => {
				const lat = Number.parseFloat(position.coords.latitude);
				const lng = Number.parseFloat(position.coords.longitude);
				if (Number.isFinite(lat) && Number.isFinite(lng)) {
					setUserPosition([lat, lng]);
					setHasGeolocated(true);
				}
			},
			(err) => {
				console.warn('Unable to retrieve user location for Trip map', err);
				setHasGeolocated(true);
			}
		);
	}, [center, hasGeolocated]);

	const effectiveCenter = useMemo(
		() => center || userPosition || fallbackCenter,
		[center, userPosition, fallbackCenter]
	);

	return {
		userPosition,
		hasGeolocated,
		setUserPosition,
		setHasGeolocated,
		effectiveCenter,
	};
}
